import { apiRequest } from './client';
import { toJsonSafe } from './json';

export async function provisionAccount({ token, companyId, company, user }) {
  return apiRequest('/api/signup', {
    token,
    method: 'POST',
    body: {
      companyId,
      company: toJsonSafe(company),
      user: toJsonSafe(user),
    },
  });
}
